module.exports = __webpack_public_path__ + "img/读卡一体机 (3).8165f30a.jpg";